/** Inline glossary term (UX spec §3.2, finding B1): dotted underline + the
 *  ops-friendly definition as a native title tooltip and aria-label. Wrap
 *  jargon-heavy column headers / labels: <Term k="slg">SLG (kA)</Term>.
 *  Unknown keys degrade to plain children — a bad key must never crash a
 *  table header. */
import type { JSX, ReactNode } from 'react'
import { GLOSSARY } from '../../content/glossary.ts'

export function Term({ k, children }: { k: string; children?: ReactNode }): JSX.Element {
  const entry = GLOSSARY[k]
  if (!entry) {
    return <span>{children}</span>
  }
  return (
    <span
      className="border-b border-dotted border-gray-400 cursor-help"
      title={entry.def}
      aria-label={`${entry.term}: ${entry.def}`}
    >
      {children ?? entry.term}
    </span>
  )
}
